import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";

import { bookingService } from "../../services/bookingService";
import { toast } from "react-toastify";
const BookingCancelModal = ({
  show,
  onHide,
  bookingId,
  isCancelled,
  setIsCancelled,
}) => {
  const [reason, setReason] = useState("");

  const handleCancel = async () => {
    if (!reason.trim()) {
      toast.error("Please enter a cancellation reason.");
      return;
    }
    try {
      const response = await bookingService.cancelBooking(bookingId, reason);
      console.log(response, "cancelled");
      toast.success(response.message);
      setIsCancelled(!isCancelled);
    } catch (e) {
      toast.error("An error occurred while canceling the booking.");
    }
    onHide(); // Đóng modal sau khi hủy
    setReason("");
  };
  return (
    <>
      {bookingId && (
        <Modal show={show} onHide={onHide} centered>
          <Modal.Body className="p-5 text-center">
            <div className="mb-4">
              <i className="isax isax-location-cross5 text-danger fs-40"></i>
            </div>
            <h5 className="mb-2">Bạn có chắc chắn muốn hủy đặt tour không?</h5>
            <p className="mb-4 text-gray-9">
              ID đặt tour: <span className="text-primary">#{bookingId}</span>
            </p>
            <div className="mb-4">
              <label className="form-label" style={{ display: "flex" }}>
                Vui lòng nhập nguyên nhân <span className="text-danger">*</span>
              </label>
              <textarea
                className="form-control"
                rows="3"
                value={reason}
                onChange={(e) => setReason(e.target.value)}
              ></textarea>
            </div>
            <div className="d-flex justify-content-center">
              <Button
                variant="light"
                className="me-2"
                onClick={() => {
                  onHide();
                  setReason("");
                }}
              >
                Không, tôi không muốn huỷ
              </Button>
              <Button variant="danger" onClick={handleCancel}>
                Vâng, tôi muốn huỷ
              </Button>
            </div>
          </Modal.Body>
        </Modal>
      )}
    </>
  );
};

export default BookingCancelModal;
